import { Card } from "@/components/ui/card";
import { Wrench, MessageSquare, Brain } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const Skills = () => {
  const { t } = useLanguage();
  
  const skillCategories = [
    {
      icon: Wrench,
      title: t("skills.categories.tools"),
      skills: [
        { name: "Blip", level: 95 },
        { name: "Typebot", level: 90 },
        { name: "Figma", level: 85 },
      ],
    },
    {
      icon: MessageSquare,
      title: t("skills.categories.conversational"),
      skills: [
        { name: t("skills.items.dialogArchitecture"), level: 92 },
        { name: t("skills.items.voiceTone"), level: 95 },
      ],
    },
    {
      icon: Brain,
      title: t("skills.categories.ai"),
      skills: [
        { name: "GPT-4 / GPT-5", level: 90 },
        { name: "Gemini", level: 88 },
        { name: t("skills.items.promptEngineering"), level: 95 },
        { name: t("skills.items.fineTuning"), level: 82 },
      ],
    },
  ];
  return (
    <section id="skills" className="py-24">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">{t("skills.title")}</h2>
          <p className="text-muted-foreground text-lg">{t("skills.subtitle")}</p>
          <div className="w-20 h-1 bg-primary mx-auto mt-6" />
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {skillCategories.map((category, index) => {
            const Icon = category.icon;
            return (
              <Card
                key={index}
                className="p-8 gradient-premium border-primary/20 animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-center gap-3 mb-6">
                  <Icon className="h-6 w-6 text-primary" />
                  <h3 className="text-xl font-bold">{category.title}</h3>
                </div>
                
                <div className="space-y-6">
                  {category.skills.map((skill, i) => (
                    <div key={i}>
                      <div className="flex justify-between mb-2">
                        <span className="font-medium">{skill.name}</span>
                        <span className="text-muted-foreground">{skill.level}%</span>
                      </div>
                      <div className="h-2 bg-secondary rounded-full overflow-hidden">
                        <div
                          className="h-full gradient-accent transition-all duration-1000 ease-out"
                          style={{ width: `${skill.level}%` }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
